import { TranslationType, SeverityCodes } from '../types';

export const errorSeverityMapping = (t: TranslationType) => {
  return {
    [SeverityCodes.error]: t('Pi-Master-Pool-Errors'),
    [SeverityCodes.requiresReview]: t('Pi-Master-Pool-Requires-Review'),
    [SeverityCodes.warning]: t('Pi-Master-Pool-Warnings')
  };
};

export const errorSeverityMappingForChipLabel = (t: TranslationType) => {
  return {
    [SeverityCodes.error]: t('Pi-Master-Pool-Error'),
    [SeverityCodes.requiresReview]: t('Pi-Portfolio-Management-Requires-Review'),
    [SeverityCodes.warning]: t('Pi-Master-Pool-Warning')
  };
};
